<template>
  <div class="user-badge">
    <div class="frame">
      <span class="initials">{{ initials }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "user-badge",
  computed: {
    ...mapGetters(["currentUser"]),
    initials() {
      if (!this.currentUser?.name) {
        return "";
      }

      const parts = this.currentUser.name.split(" ");
      if (parts.length === 1) {
        return parts[0].substring(0, 2);
      } else if (parts.length > 1) {
        if(parts[1][0]) {
          return `${parts[0][0]}${parts[1][0]}`;
        }
        return parts[0].substring(0, 2);        
      }
      return "--";
    },
  },
};
</script>

<style lang="scss" scoped>
.user-badge {
  .frame {
    border: 2px solid white;
    border-radius: 50%;
    min-width: 45px;
    min-height: 45px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    .initials {
      color: white;
    }
  }
}
</style>
